// scene-2/icons-as-images.js
export function scene2IconToImages() {
  const scene2 = document.querySelector(".scene-2");
  if (!scene2) return;

  // One paragraph → one icon sequence (order matters)
  // Adjust basePath + totalFrames for each icon
  const ICONS = [
    { basePath: "/custom/images/animations-image-seq/hand/", total: 43, pad: 2, ext: "webp" }, // 00..49
    { basePath: "/custom/images/animations-image-seq/arrow/", total: 34, pad: 2, ext: "webp" },
    { basePath: "/custom/images/animations-image-seq/star/", total: 30, pad: 2, ext: "webp" },
  ];

  const paragraphs = scene2.querySelectorAll(".content_text p");
  paragraphs.forEach((p, index) => {
    const conf = ICONS[index];
    // If there are more <p> than configs, skip extra ones gracefully
    if (!conf) return;

    const container = document.createElement("div");
    container.className = "scene-2-text-container";

    // First frame in markup so there’s no flash before JS kicks in
    const first = `${conf.basePath}${String(0).padStart(conf.pad ?? 2, "0")}.${conf.ext || "webp"}`;
    container.innerHTML = `
      <img class="scene-2-icon" alt=""
           src="${first}"
           width="128" height="128"
           style="opacity:0; transform: translateX(-12px); will-change: transform,opacity;" />
      ${p.outerHTML}
    `;

    p.parentNode.insertBefore(container, p);
    p.remove();
  });
}

// CODE BEFORE CHANGING TO IMAGES
//=============================
//=============================
//=============================
//=============================
//=============================
//=============================
//=============================
//=============================

export function scene2IconToVideo() {
  const scene2 = document.querySelector(".scene-2");
  const paragraphs = scene2.querySelectorAll(".content_text p");

  // Define a custom image path for each paragraph (order matters)
  const imagePathsWebM = ["/custom/images/webm/hand1.webm", "/custom/images/webm/arrow1.webm", "/custom/images/webm/star023.webm"];
  const imagePathsMp4 = ["/custom/images/webm/hand-mp-black.mp4", "/custom/images/webm/arrow-mp-black.mp4", "/custom/images/webm/star-mp-black.mp4"];

  paragraphs.forEach((p, index) => {
    const container = document.createElement("div");
    container.className = "scene-2-text-container";

    // Use the corresponding image path
    const imgSrcWebM = imagePathsWebM[index] || "/custom/images/default.webp";
    const imgSrcMp4 = imagePathsMp4[index] || "/custom/images/default.webp";

    container.innerHTML = `
        <video id="video-icon--${index}" muted playsinline style="pointer-events:none;">
  <source src="${imgSrcWebM}" type="video/webm">
    <source src="${imgSrcMp4}" type="video/mp4">
  Your browser does not support the video tag.
</video>
        ${p.outerHTML}
      `;

    // Insert before original <p> then remove <p>
    p.parentNode.insertBefore(container, p);
    p.remove();
  });
}
